<template>
  <game-template :success="finished">
    <template v-if="!finished" v-slot:head>
      <p class="title">
        Cliquez aux bons endroits pour déclarer le temps de travail de Sandra
      </p>
      <p class="sub-title">
        Sélectionnez au fur et à mesure les zones roses encadrées de pointillés
      </p>
      <div class="step-label-wrapper">
        <p class="step-index">
          {{ 1 + stepIndex }}
        </p>
        <p class="step-label">
          {{ step.label }}
        </p>
      </div>
    </template>
    <template v-else-if="finished" v-slot:head>
      <p class="title">
        Félicitations ! Le temps moyen journalier de Sandra a bien été mis à jour.
      </p>
      <p class="sub-title">
        Son temps de travail hebdomadaire sera mis à jour dès demain par le système GTA.
      </p>
      <button class="button" @click="next">Continuer</button>
    </template>
    <template v-slot:content>
      <div class="saisie-absence-game">
        <div class="gta-wrapper">
          <div @click="svgClick" class="svg-wrapper" ref="svg" v-html="require(`../assets/gta-ui.svg?inline`)"></div>
        </div>
      </div>
    </template>
  </game-template>
</template>

<script>
import stepMixin from '@shared/mixins/stepMixin'

export default {
  name: 'SaisieTravailGame',
  mixins: [stepMixin],
  data () {
    return {
      steps: [
        {
          name: 'planing',
          label: 'Ouvrir le "planning collectif"',
          clickableZone: 'hint-1',
          item: 'item-1'
        },
        {
          name: 'periode',
          label: 'Sélectionner la période concernée',
          clickableZone: 'hint-2',
          item: 'item-2'
        },
        {
          name: 'select-horaire',
          label: 'Sélectionner l\'horaire à modifier',
          clickableZone: 'hint-3',
          item: 'item-3'
        },
        {
          name: 'modif-horaire',
          label: 'Modifier les horaires',
          clickableZone: 'hint-4',
          item: 'item-4'
        },
        {
          name: 'valid-modif',
          label: 'Valider les modifications',
          clickableZone: 'hint-5',
          item: 'item-5'
        },
        {
          name: 'save',
          label: 'Enregistrer',
          clickableZone: 'hint-6',
          item: 'item-6'
        }
      ],
      stepIndex: 0,
      finished: false
    }
  },
  computed: {
    step () {
      return this.steps[this.stepIndex]
    }
  },
  methods: {
    nextStep () {
      if (this.stepIndex < this.steps.length - 1) {
        this.stepIndex++
        if (this.stepIndex === 3) {
          this.showSpecialStep()
        }
        if (this.stepIndex === 5) {
          this.$refs.svg.querySelector('.item-45').style.display = 'block'
          this.$refs.svg.querySelector('.special-step').style.visibility = 'hidden'
        }
      } else {
        this.finished = true
        this.$store.commit('setIsGameFinished', true)
      }
    },
    svgClick (evt) {
      const goodZoneClick = evt.target.classList.contains(this.step.clickableZone)
      if (goodZoneClick) {
        this.$refs.svg.querySelector('.' + this.step.item).classList.add('activ')
        this.nextStep()
      } else {
        let overlay = ''
        if (this.stepIndex === 3 || this.stepIndex === 4) {
          overlay = this.$refs.svg.querySelector('.overlay-special')
        } else {
          overlay = this.$refs.svg.querySelector('.overlay')
        }
        overlay.classList.add('visible')
        window.setTimeout(() => {
          overlay.classList.remove('visible')
        }, 200)
      }
    },
    showSpecialStep () {
      this.$refs.svg.querySelector('.special-step').style.visibility = 'visible'
    }
  }
}
</script>

<style lang="scss">
.step-label-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
  margin-bottom: 5px;
  .step-index {
    width: 40px;
    height: 40px;
    background-color: $secondary-color;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
    font-size: 1.2rem;
    border-radius: 50%;
    margin-right: 15px;
  }
  .step-label {
    background-color: #fff;
    border-radius: $radius-sm;
    padding: 15px 40px;
    font-weight: 700;
  }
}
.saisie-absence-game {
  position: relative;
  .svg-wrapper {
    max-width: 100%;
    svg {
      min-height: 500px;
      max-width: 100%;
      text {
        font-weight: 700;
        font-family: $primary-font;
      }
      .overlay, .overlay-special {
        transition: opacity 0.3s;
        opacity: 0;
        &.visible {
          opacity: .4;
        }
      }
      .item {
        .hint {
          cursor: pointer;
          &:hover {
            rect {
              transition: opacity 0.3s ease-out;
              opacity: 0;
            }
          }
        }
        .bubble {
          transition: opacity 0.3s ease-out;
          opacity: 0;
        }
        &.activ {
          .bubble {
            opacity: 1;
          }
        }
      }
    }
  }
}
</style>
